export default __webpack_public_path__ + "static/media/logo.781684b9.svg";